import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './app/page';

const About = lazy(() => import('./app/about/page'));
const Services = lazy(() => import('./app/services/page'));
const Cases = lazy(() => import('./app/cases/page'));
const Knowledge = lazy(() => import('./app/knowledge/page'));
const GeoNewsArchivePage = lazy(() => import('./app/knowledge/GeoNewsArchivePage'));
const GeoNewsArticlePage = lazy(() => import('./app/knowledge/GeoNewsArticlePage'));
const GeoKnowledgeArticlePage = lazy(() => import('./app/knowledge/GeoKnowledgeArticlePage'));
const Compliance = lazy(() => import('./app/compliance/page'));
const ArticleDetail = lazy(() => import('./app/articledetail/page'));
const CaseDetail = lazy(() => import('./app/casedetail/page'));
const CaseImageDetailPage = lazy(() => import('./app/casedetail/CaseImageDetailPage'));
const Product = lazy(() => import('./app/product/page'));
const FAQ = lazy(() => import('./app/faq/page'));

const RouteFallback = () => (
  <div className="min-h-[40vh] bg-[#F5F6F8]" aria-hidden="true" />
);

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/cases" element={<Cases />} />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/knowledge/library" element={<Knowledge />} />
            <Route path="/knowledge/library/:id" element={<GeoKnowledgeArticlePage />} />
            <Route path="/knowledge/:category" element={<GeoNewsArchivePage />} />
            <Route path="/knowledge/:category/:id" element={<GeoNewsArticlePage />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/articledetail" element={<ArticleDetail />} />
            <Route path="/casedetail" element={<CaseDetail />} />
            <Route path="/cases/:slug" element={<CaseImageDetailPage />} />
            <Route path="/product" element={<Product />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
